<template>
    <form @submit.prevent="handleSubmit">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Postpone</p>
            </header>
            <section class="modal-card-body is-flex">
                 <o-field label="Postpone remind by date:">
                    <datepicker :config="config" v-model="date" :absolute="true" :required="true" v-bind:class="{ 'is-danger': !date }" />
                </o-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click="handleClick()" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Datepicker from './../Datepicker'


    export default {
        mixins: [],

        components: {
            Datepicker
        },

        props: {
            entity_type: {
                type: String // change-order, proposal
            },
            entity: {
                type: Object
            }
        },

        mounted() {
           this.date = this.entity.remind_by
        },

        data () {
            return {
                config: {
                    minDate: 'today'
                },
                date: null,
            }
        },

        methods: {
            ...mapActions(['updateChangeOrderRemindBy', 'updateProposalRemindBy']),
            updateRemindBy(obj) {
                switch(this.entity_type){
                    case 'change-order' :
                        this.updateChangeOrderRemindBy(obj)
                        break
                    case 'proposal' :
                        this.updateProposalRemindBy(obj)
                        break
                }
            },
            handleClick() {
                this.updateRemindBy({ id: this.entity.id, remind_by: this.date})
                this.$parent.$parent.$emit('update:active', false)
            },
            handleSubmit() {
                return false
            }
        },

        computed: {
            ...mapGetters([])
        }
    }
</script>
<style scoped>
    .modal-card-foot {
        justify-content: flex-end;
    }

    .modal-card-foot button {
        margin: 0px 2px;
        min-width: 80px;
        justify-content: center;
    }

    .modal .modal-card {
        max-width: 460px;
        width: auto;
    }
    .modal .modal-card .modal-card-head {
        font-size: 1.25rem;
        font-weight: 600;
    }
</style>
